export const SelectAll = {
  mounted() {
    const el = this.el as HTMLElement
    const header = el.querySelector<HTMLInputElement>("[data-select-all]")
    if (!header) return

    const rows = () =>
      Array.from(el.querySelectorAll<HTMLInputElement>("[data-select-row]"))

    const syncHeader = () => {
      const all = rows()
      const checked = all.filter((r) => r.checked).length
      header.checked = checked === all.length && all.length > 0
      header.indeterminate = checked > 0 && checked < all.length
    }

    header.addEventListener("change", () => {
      rows().forEach((cb) => {
        cb.checked = header.checked
      })
    })

    el.addEventListener("change", (e) => {
      if ((e.target as HTMLInputElement).matches("[data-select-row]")) {
        syncHeader()
      }
    })
  },
}
